import HeaderLegacyLinksPopoverModule from './header-legacy-links-popover.module'

export default HeaderLegacyLinksPopoverModule
